import { colors } from 'assets/styled/tokens';
import styled from 'styled-components';

export const TransparentBg = styled.div`
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 1000;
  overflow-y: auto;
  padding: 0 16px;
`;

export const ModalBody = styled.div`
  height: auto;
  width: 100%;
  max-width: 448px;
  min-width: 0;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
`;

export const Header = styled.div`
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #e8e1de;
  display: flex;
  flex-direction: row;
  padding: 15px;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h1`
  font-family: Blinker;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.5px;
  vertical-align: middle;
  color: ${colors.primary};
`;

export const CloseModalButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #e8e1de;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
